import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 19 15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M14.906 7.08a2.396 2.396 0 0 0 2.06-2.367c0-1.19-.867-2.176-2.005-2.363"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#7A472A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M16.438 9.875c1.125.169 1.911.563 1.911 1.375 0 .56-.37.923-.968 1.151"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M9.903 10.22c-2.678 0-4.966.406-4.966 2.026s2.274 2.038 4.966 2.038c2.679 0 4.965-.402 4.965-2.023 0-1.622-2.272-2.041-4.965-2.041M9.905 7.907a3.182 3.182 0 1 0-3.182-3.183 3.17 3.17 0 0 0 3.159 3.183z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.25",
      d: "M4.904 7.08a2.396 2.396 0 0 1-2.06-2.367c0-1.19.867-2.176 2.005-2.363M3.369 9.875c-1.126.169-1.912.563-1.912 1.375 0 .56.37.923.968 1.151"
    }, null, -1)
  ]))]))
}
export default { render: render }